export const PASSWORD = "bookmarks-webhook-password"

export const getPassword = (): string | null => localStorage.getItem(PASSWORD)

export const setPassword = (value: string): void => {
  localStorage.setItem(PASSWORD, value)
}

export const IS_AUTH = !!getPassword()